import { render, staticRenderFns } from "./AdvDetail.vue?vue&type=template&id=71f1bed6&"
import script from "./AdvDetail.vue?vue&type=script&lang=js&"
export * from "./AdvDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AdvDetail.vue"
export default component.exports